module.exports = __webpack_public_path__ + "img/IMG020.cd2b30cf.jpg";